import { InjectionToken } from "@angular/core";
import { marker } from "@biesbjerg/ngx-translate-extract-marker";

export const defaultErrors = {
    required: (error) => marker(`Fehlende Eingabe`),
    requiredIf: (error) => marker(`Fehlende Eingabe`),
    requiredTrue: (error) => marker(`Fehlende Eingabe`),
    email: (error) => marker(`Keine gültige E-Mail Adresse`),
    minlength: ({ requiredLength, actualLength }) => marker(`Mindestzeichen beachten`),
    maxlength: ({ requiredLength, actualLength }) => marker(`Zu Viele Zeichen verwendet`),
};

export const FORM_ERRORS = new InjectionToken("FORM_ERRORS", {
    providedIn: "root",
    factory: () => defaultErrors,
});
